<!-- PatientEpaHistory.vue -->
<script lang="ts" setup>
import { onBeforeMount, reactive, ref } from 'vue';
import { ChoiceApi } from '../../../LibMain';
import { popAlert } from '../../../lib/Notification';
import { IPatientEpaHistoryItem } from '../../../lib/Api/Patient';
import { IDatabaseIdModel } from '../../../lib/Models/DatabaseIdModel';
import { DatabaseIdTypes, PortalType, AppScreens } from '../../../Enums/ChoiceEnums';
import PatientHeader from '../../../components/Choice/Patient/PatientHeader.vue';
import PageTitle from '../../../components/PageTitle.vue';
import ChoiceTable from '../../../components/ChoiceTable.vue';
import { ICol, RenderModeType } from '../../../lib/ChoiceTableHelpers';

    const props = defineProps<{
        patientId: IDatabaseIdModel
    }>();

    const compData = reactive<{
        patientEpaHistory?: IPatientEpaHistoryItem[],
        patientEntityId?: number
    }>({});

    const historyTableColumns = ref<ICol[]>([
        { Name: 'ePA Status', DataField: 'ePATaskStatus' },
        { Name: 'Prescription', DataField: 'drugShortName' },
        { Name: 'SIG', DataField: 'SIG' },
        { Name: 'RX Start Date', DataField: 'startDate', RenderMode: RenderModeType.PrettyDate },
        { Name: 'RX Prescriber', DataField: 'providerName' },
        { Name: 'PA Case ID', DataField: 'caseId' },
        { Name: 'RX Id', DataField: 'prescriptionId' }
    ]);


    onBeforeMount(async () =>{

        if (DatabaseIdTypes.patient_id === props.patientId.idType)
        {
            ChoiceApi.patient.entity(<number>props.patientId.id).then(entityInfo => {
                compData.patientEntityId = entityInfo?.entity_id;
            });
        }
        else if (DatabaseIdTypes.patient_entity_id === props.patientId.idType)
        {
            compData.patientEntityId = <number>props.patientId.id;
        }
        else
        {
            await popAlert(`Invalid patientId.idType: ${props.patientId.idType}`);
        }

        const respHistory = await ChoiceApi.patient.patientEpaHistory(props.patientId);
        if (!respHistory)
        {
            await popAlert("Error getting patient ePA history");
            return;
        }
        compData.patientEpaHistory = respHistory;
    });
</script>

<template>
    <PageTitle :security-screen-name="AppScreens.CoverMyMedsEPA">
        <template #permitted>
            <PatientHeader v-if="compData.patientEntityId" :patientEntityId="compData.patientEntityId" :displayContext="PortalType.Emr" :legacyPage="false" />

            <ChoiceTable :columns="historyTableColumns" :data="compData.patientEpaHistory"/>
        </template>
    </PageTitle>
</template>